import React, { useState } from 'react';
import { Eye, Rocket } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import UpgradePrompt from './UpgradePrompt';

const GuestBanner = () => {
  const { isGuest } = useAuth();
  const [open, setOpen] = useState(false);

  if (!isGuest) return null;

  return (
    <>
      <div
        className="w-full bg-gradient-to-r from-yellow-500/15 via-orange-500/15 to-yellow-500/15 border-b border-yellow-500/30 backdrop-blur"
        data-testid="guest-mode-banner"
      >
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2 text-sm text-yellow-100">
            <Eye size={16} weight="fill" className="text-yellow-400 flex-shrink-0" />
            <span className="font-medium">
              <span className="font-bold text-yellow-400">Guest Mode</span> — you're exploring a preview. Trading & game modes require a free account.
            </span>
          </div>
          <button
            onClick={() => setOpen(true)}
            className="flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-bold text-xs hover:scale-105 transition-transform whitespace-nowrap"
            data-testid="guest-banner-signup"
          >
            <Rocket size={14} weight="fill" /> Sign Up Free
          </button>
        </div>
      </div>
      <UpgradePrompt open={open} onClose={() => setOpen(false)} action="create your account" />
    </>
  );
};

export default GuestBanner;
